import { z } from 'zod';
import { normalizedUuidSchema } from './common';

/** parentId는 상품의 대표 소분류(categories.id)다. 실제 규칙 값은 운영자가 정한다. */
export const parentRecommendationRuleSchema = z.strictObject({
  parentId: normalizedUuidSchema,
  priority: z.number().int().min(1).max(1_000_000),
  maxItems: z.number().int().min(1).max(1_000_000),
});
export type ParentRecommendationRule = z.infer<typeof parentRecommendationRuleSchema>;

const parentRulesSchema = z
  .array(parentRecommendationRuleSchema)
  .max(100)
  .superRefine((rules, ctx) => {
    const parentIds = new Set<string>();
    rules.forEach(({ parentId }, index) => {
      if (parentIds.has(parentId)) {
        ctx.addIssue({
          code: 'custom',
          path: [index, 'parentId'],
          message: '같은 부모 규칙을 중복해서 지정할 수 없습니다.',
        });
      }
      parentIds.add(parentId);
    });
  });

const settingsShape = {
  popularityWindowDays: z.number().int().min(1).max(365),
  viewWeight: z.number().int().min(0).max(1_000_000),
  quoteWeight: z.number().int().min(0).max(1_000_000),
  orderWeight: z.number().int().min(0).max(1_000_000),
  parentRules: parentRulesSchema,
};

export const updateRecommendationSettingsInputSchema = z.strictObject(settingsShape);
export type UpdateRecommendationSettingsInput = z.infer<
  typeof updateRecommendationSettingsInputSchema
>;

export const recommendationSettingsSchema = z.strictObject({
  ...settingsShape,
  id: z.literal(1),
  updatedAt: z.iso.datetime(),
});
export type RecommendationSettings = z.infer<typeof recommendationSettingsSchema>;
